import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Form, Input, TimePicker } from 'antd';
import { useSelector } from 'react-redux';
import { openMessage } from '../../../redux/actions';
import regex, { NOTIFIES } from '../../../constants/system.keys';

const layout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 16 },
};

const format = 'HH:mm';

const AddWhitelistIPComponent = ({ namespace, onAdd, onDone }) => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const [, forceUpdate] = useState();
  const { addWhiteListIPs } = useSelector((state) => state);
  const [addDataReturn, setAddDataReturn] = useState();
  const [requestId, setRequestId] = useState();
  const ipAddressRef = useRef(null);
  useEffect(() => {
    if (addWhiteListIPs && addWhiteListIPs.requestId === requestId) {
      setAddDataReturn(addWhiteListIPs);
    }
  }, [addWhiteListIPs, requestId]);

  useEffect(() => {
    if (addDataReturn) {
      const { result, data, message } = addDataReturn;
      if (result === -3) {
        form.setFields([
          {
            name: 'ipAddress',
            errors: [message],
          },
        ]);
      }
      if (result === 1) {
        openMessage(NOTIFIES.SUCCESS, message);
        onDone(data);
      }
    }
  }, [addDataReturn, form, onDone]);

  useEffect(() => {
    form.resetFields();
    forceUpdate({});
  }, [form]);
  useEffect(() => {
    if (namespace) {
      form.setFieldsValue({
        namespace: namespace,
      });
    }
  }, [form, namespace]);

  useEffect(() => {
    if (ipAddressRef.current) {
      setTimeout(() => { ipAddressRef.current.input.focus() }, 1)
    }
  }, [ipAddressRef]);

  const onFinish = (values) => {
    const fromMinute = values['fromMinute']
      ? values['fromMinute'].minutes() + values['fromMinute'].hours() * 60
      : 0;
    const toMinute = values['toMinute']
      ? values['toMinute'].minutes() + values['toMinute'].hours() * 60
      : 1439;
    let current = new Date().getTime();
    setRequestId(current);
    return onAdd(current, { ...values, fromMinute, toMinute });
  };
  return (
    <div className="add-whitelist-ip-component">
      <Form form={form} {...layout} onFinish={onFinish} name="form_in_modal">
        <Form.Item
          name="ipAddress"
          label={t('IP Address')}
          rules={[
            {
              required: true,
              message: t('Please input the IP address!'),
            },
            {
              pattern: regex.isurl,
              message: t('Please input the IP address!'),
            },
            {
              max: 200,
              message: t('Please input up to 200 characters!'),
            },
          ]}
        >
          <Input ref={ipAddressRef} placeholder={t('IP Address')} />
        </Form.Item>
        <Form.Item
          name="namespace"
          label={t('Namespace')}
          rules={[
            {
              required: true,
              message: t('Please input the namespace!'),
            },
            {
              pattern: regex.isurl,
              message: t('Please input the namespace!'),
            },
            {
              max: 80,
              message: t('Please input up to 80 characters!'),
            },
          ]}
        >
          <Input disabled placeholder={t('Namespace')} />
        </Form.Item>
        <Form.Item name="fromMinute" label={t('From')}>
          <TimePicker format={format} />
        </Form.Item>
        <Form.Item name="toMinute" label={t('To')}>
          <TimePicker format={format} />
        </Form.Item>

        <div className="create-btn">
          <Form.Item shouldUpdate={true}>
            <Button type="primary" htmlType="submit">
              {t('Create')}
            </Button>
          </Form.Item>
        </div>
      </Form>
    </div>
  );
};

export default AddWhitelistIPComponent;
